import {Command, CommandMeta, DeriveJSONSchema, SimpleSchema} from "mobx-graphlink";
import {Activity} from "../DB/activities/@Activity";

const MTClass = Activity;
type MT = typeof MTClass.prototype;

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		entry: DeriveJSONSchema(MTClass, {}),
	}),
	responseSchema: ()=>SimpleSchema({id: {$ref: "UUID"}}),
})
export class AddActivity extends Command<{entry: MT}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		$id: {$ref: "UUID"},
		$updates: DeriveJSONSchema(MTClass, {excludeKeys: ["id", "creator"], makeOptional_all: true}),
	}),
})
export class UpdateActivity extends Command<{id: string, updates: Partial<MT>}> {}

@CommandMeta({
	inputSchema: ()=>SimpleSchema({
		id: {$ref: "UUID"},
	}),
})
export class DeleteActivity extends Command<{id: string}> {}